
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import GTag from '../components/GTag';
function Puneairportcabs() {



    const cardData =
    {
        keyword: 'Pune Airport Cabs',
        heading: 'Mauli Cabs: Pune Airport Cabs',
        headingDescription: 'Mauli Cabs offers prompt and reliable Pune Airport cab services, ensuring timely pickups and drop-offs for a stress-free travel experience. Whether you are arriving in the city or heading to the airport, we provide a fleet of well-maintained vehicles including sedans, SUVs, and premium cabs to match your comfort and budget. With experienced drivers, transparent pricing, no hidden charges, and a strong focus on punctuality and customer satisfaction, Mauli Cabs guarantees a smooth and hassle-free airport transfer every time.',

        top: 'Top Places to Visit in Pune with Mauli Cabs',

"topPlaces": [
    {
        "title": "Shaniwar Wada",
        "description": "A historic fortification in the heart of Pune, Shaniwar Wada was the seat of the Peshwas of the Maratha Empire and is known for its majestic architecture and legends."
    },
    {
        "title": "Aga Khan Palace",
        "description": "Built in 1892, the Aga Khan Palace is a beautiful monument of national importance, known for its connection to Mahatma Gandhi and India's freedom movement."
    },
    {
        "title": "Sinhagad Fort",
        "description": "Located around 30 km from Pune, Sinhagad Fort is a popular trekking spot with rich historical significance and panoramic views of the Sahyadri hills."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "An 8th-century rock-cut temple carved out of a single basalt rock, Pataleshwar Cave Temple is dedicated to Lord Shiva and offers a peaceful spiritual retreat."
    },
    {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "One of the most famous Ganpati temples in Maharashtra, this temple is known for its rich history, beautiful idol, and grand Ganesh Chaturthi celebrations."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "This museum houses an impressive collection of over 20,000 artifacts showcasing Indian arts, crafts, and culture, curated by Dr. Dinkar Kelkar."
    },
    {
        "title": "Parvati Hill and Temple",
        "description": "Parvati Hill is one of the oldest heritage sites in Pune, offering a temple complex atop a hill with stunning views of the city."
    },
    {
        "title": "Osho Ashram",
        "description": "Located in Koregaon Park, Osho Ashram is a spiritual retreat offering meditation programs and a serene environment, attracting visitors from around the world."
    },
    {
        "title": "Pune Okayama Friendship Garden",
        "description": "Also known as Pu La Deshpande Garden, this is a Japanese-style landscape garden perfect for relaxing walks and photography."
    },
    {
        "title": "Katraj Snake Park and Rajiv Gandhi Zoological Park",
        "description": "This zoo and snake park features a wide variety of reptiles and animals, making it a favorite spot for families and children."
    }
],

"services": [
    {
      "name": "Pune Airport Cabs",
      "description": "Book Pune Airport cabs for timely pickups and drop-offs. We offer a wide range of vehicles including hatchbacks, sedans, SUVs, and luxury cars to suit every traveler's needs, with real-time tracking and professional chauffeurs."
    },
    {
      "name": "Mumbai Airport to Pune Cab",
      "description": "Get a comfortable cab from Mumbai Airport to Pune. Our service includes flight monitoring, on-time pickups, experienced drivers, and various vehicle options for individuals and groups alike."
    },
    {
      "name": "Pune Airport Cab Services",
      "description": "Reliable cab services from Pune Airport for local city travel or outstation trips. Clean vehicles, courteous drivers, and 24/7 availability ensure a stress-free experience for every passenger."
    },
    {
      "name": "Pune Airport Taxi Booking",
      "description": "Book your Pune Airport taxi instantly via phone or online portal. Quick confirmations, multiple payment modes, and fixed rates make travel convenient and secure."
    },
    {
      "name": "Pune Airport Car Rental",
      "description": "Flexible car rental options from Pune Airport with or without drivers. Rent vehicles on an hourly, daily, or trip basis. Ideal for business travel, tourist visits, or personal errands."
    },
    {
      "name": "Pune Airport Taxi Rate",
      "description": "Check our transparent Pune Airport taxi rates with no hidden fees. Pricing is calculated based on vehicle type, distance, and service level chosen."
    },
    {
      "name": "Pune Airport Cab Charges",
      "description": "Explore affordable Pune Airport cab charges tailored to your trip type. Choose from one-way, round-trip, or outstation options at fair, upfront prices."
    },
    {
      "name": "Pune Airport Taxi Booking Online",
      "description": "Easily book a taxi online from Pune Airport to any location. Real-time availability, secure payments, and instant confirmations included."
    },
    {
      "name": "Pune Airport Cab Pricing",
      "description": "Get detailed cab pricing from Pune Airport to popular destinations like Mumbai, Shirdi, or Lonavala. Choose based on your budget and travel needs."
    },
    {
      "name": "Pune Airport Car Hire with Driver",
      "description": "Hire a car with a professional driver from Pune Airport. Ideal for business executives, tourists, or group travelers wanting local knowledge and safe travel."
    },
    {
      "name": "Pune to Shirdi Cab One Way",
      "description": "One-way cab service from Pune to Shirdi for a comfortable pilgrimage or short trip. Get door-to-door transfers with flexible departure times."
    },
    {
      "name": "Pune to Mumbai Airport Cab Fare",
      "description": "Know your fare in advance for Pune to Mumbai Airport transfers. Competitive pricing with detailed cost breakdown including tolls and night charges."
    },
    {
      "name": "Pune to Mumbai Airport",
      "description": "Book trusted cabs from Pune to Mumbai Airport. On-time pickups, comfortable rides, and experienced drivers ensure a worry-free transfer."
    },
    {
      "name": "Pune Mumbai Airport Drop",
      "description": "One-way drop taxi from Pune to Mumbai Airport. Ideal for early morning or late-night flights with punctual service and fixed charges."
    },
    {
      "name": "Pune Airport to Shirdi Cab",
      "description": "Travel directly from Pune Airport to Shirdi in a clean, comfortable cab. Available 24/7 with various vehicle categories and trained chauffeurs."
    },
    {
      "name": "One Way Cab Mumbai to Pune",
      "description": "Affordable one-way cabs from Mumbai to Pune. Ideal for travelers avoiding round-trip charges, with timely pickups and a fleet of AC vehicles."
    },
    {
      "name": "Pune Mumbai Cab Service",
      "description": "Premium cab service between Pune and Mumbai. Choose from economy to luxury vehicles with flexible pickup locations and easy booking."
    },
    {
      "name": "Pune to Mumbai Taxi Service",
      "description": "Book a dependable taxi from Pune to Mumbai with fixed fares, safe drivers, and well-maintained vehicles. Ideal for business or leisure travel."
    },
    {
      "name": "Pune Airport to Shirdi Taxi",
      "description": "Get a dedicated taxi from Pune Airport to Shirdi. Prompt service with GPS-tracked vehicles and professional drivers for your temple visit."
    },
    {
      "name": "Airport Taxi Pune",
      "description": "Airport taxi services in Pune with a focus on punctuality, cleanliness, and customer satisfaction. Options available for all budgets and travel preferences."
    },
    {
      "name": "Pune Airport Taxi",
      "description": "Taxi services for Pune Airport arrivals and departures. Schedule your ride in advance for smooth transitions to your destination."
    },
    {
      "name": "Outstation Car Rental Pune",
      "description": "Plan an outstation trip from Pune with our car rental service. Multiple vehicle types available for round trips or multi-day journeys."
    },
    {
      "name": "Airport Drop Pune",
      "description": "Need a cab to Pune Airport? Our airport drop service ensures timely arrivals, flight tracking, and 24/7 availability."
    },
    {
      "name": "Pune Airport to Shirdi Cab Price",
      "description": "Check updated pricing for cab rides from Pune Airport to Shirdi. Transparent fare with no last-minute charges or surge pricing."
    },
    {
      "name": "Airport Cab Service Pune",
      "description": "Affordable and punctual airport cab service in Pune. Book online or offline with flexible vehicle choices and courteous drivers."
    },
    {
      "name": "Airport Pickup and Drop Pune",
      "description": "Round-the-clock airport pickup and drop services in Pune. Ideal for business travelers, tourists, and families seeking comfort and efficiency."
    },
    {
      "name": "Airport Taxi Service in Pune",
      "description": "Professional taxi service to and from Pune Airport. Enjoy reliable rides with real-time updates and customer-focused support."
    },
    {
      "name": "Book Airport Cab Pune",
      "description": "Book an airport cab in Pune in seconds through our app or website. Competitive pricing and flexible scheduling make travel simple."
    },
    {
      "name": "Book Cab for Pune Airport",
      "description": "Pre-book your cab for Pune Airport departure. Beat the rush and reach on time with our dependable drivers and well-maintained cars."
    },
    {
      "name": "Cheapest Ashtavinayak Tour from Pune",
      "description": "Budget-friendly Ashtavinayak Darshan tours starting from Pune. Comfortable travel, experienced drivers, and spiritual convenience all in one."
    }
  ],
  "tableData": [
    ["Pune Airport Cabs", "Mumbai Airport to Pune Cab"],
    ["Pune Airport Cab Services", "Pune Airport Taxi Booking"],
    ["Pune Airport Car Rental", "Pune Airport Taxi Rate"],
    ["Pune Airport Cab Charges", "Pune Airport Taxi Booking Online"],
    ["Pune Airport Cab Pricing", "Pune Airport Car Hire with Driver"],
    ["Pune to Shirdi Cab One Way", "Pune to Mumbai Airport Cab Fare"],
    ["Pune to Mumbai Airport", "Pune Mumbai Airport Drop"],
    ["Pune Airport to Shirdi Cab", "One Way Cab Mumbai to Pune"],
    ["Pune Mumbai Cab Service", "Pune to Mumbai Taxi Service"],
    ["Pune Airport to Shirdi Taxi", "Airport Taxi Pune"],
    ["Pune Airport Taxi", "Outstation Car Rental Pune"],
    ["Airport Drop Pune", "Pune Airport to Shirdi Cab Price"],
    ["Airport Cab Service Pune", "Airport Pickup and Drop Pune"],
    ["Airport Taxi Service in Pune", "Book Airport Cab Pune"],
    ["Book Cab for Pune Airport", "Cheapest Ashtavinayak Tour from Pune"]
  ],



"whychoose": [
    {
        "WhyChooseheading": "Reliable Airport Transfers",
        "WhyChoosedescription": "Mauli Cabs offers prompt and reliable cab services to and from Pune Airport. Whether it's an early morning flight or a late-night arrival, count on us for timely pickups and drops."
    },
    {
        "WhyChooseheading": "Wide Range of Vehicles",
        "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, and premium cars to match your comfort and budget. Our Pune Airport Cabs are well-maintained and equipped with ample luggage space."
    },
    {
        "WhyChooseheading": "Professional and Punctual Drivers",
        "WhyChoosedescription": "Our experienced drivers ensure you reach the airport on time or get home comfortably after a flight. They are courteous, well-trained, and punctual."
    },
    {
        "WhyChooseheading": "Easy Online Booking",
        "WhyChoosedescription": "Book your Pune Airport Cab instantly through our website or mobile app. With just a few clicks, your ride will be confirmed with real-time tracking and updates."
    },
    {
        "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
        "WhyChoosedescription": "Enjoy affordable fares and transparent billing. What you see is what you pay—no last-minute surprises or hidden fees."
    },
    {
        "WhyChooseheading": "24/7 Availability",
        "WhyChoosedescription": "Mauli Cabs operates round the clock to cater to all your airport transfer needs. Whether you need a ride at midnight or dawn, we’re always available."
    },
    {
        "WhyChooseheading": "Safe and Hygienic Travel",
        "WhyChoosedescription": "All our cabs are sanitized regularly and driven by background-verified drivers. With GPS tracking and safety protocols in place, your security is our priority."
    },
    {
        "WhyChooseheading": "Corporate and Regular Travel Packages",
        "WhyChoosedescription": "For frequent flyers and business travelers, we offer special packages with discounted rates and priority booking for Pune Airport Cabs."
    }
]



















    }



    const faqData = [
        {
            question: 'How do I book a cab to or from Pune Airport with Mauli Cabs?',
            answer: 'Booking a Pune Airport cab is easy with Mauli Cabs. Simply use our website or mobile app, select your pickup and drop-off locations with Pune Airport as either origin or destination, choose your vehicle, and confirm your booking. You can also book by calling our support team.',
        },
        {
            question: 'What types of cabs are available for Pune Airport transfers?',
            answer: 'We provide a variety of cab options including Hatchbacks, Sedans, SUVs, Ertiga, and Innova Crysta for Pune Airport transfers. Choose according to your budget, comfort level, and luggage requirements.',
        },
        {
            question: 'Is the fare for Pune Airport cab service fixed?',
            answer: 'Yes, Mauli Cabs offers fixed and transparent pricing for Pune Airport transfers. The fare includes all tolls, fuel charges, and driver fees, with no hidden costs.',
        },
        {
            question: 'Can I book a cab for early morning or late-night flights?',
            answer: 'Absolutely. We operate 24/7 to accommodate all flight timings. Just mention your preferred pickup time during booking and we’ll ensure timely service.',
        },
        {
            question: 'Will the driver help with luggage at the airport?',
            answer: 'Yes, our drivers are courteous and assist passengers with their luggage at both pickup and drop-off points for a smooth experience.',
        },
        {
            question: 'Can I schedule a pickup in advance for Pune Airport?',
            answer: 'Yes, you can schedule your pickup in advance through our app, website, or by calling customer support. Advance bookings help ensure timely and reliable service, especially during peak hours.',
        },
        {
            question: 'Are Mauli Cabs drivers familiar with Pune Airport terminals?',
            answer: 'Yes, our drivers are well-acquainted with Pune Airport’s layout and drop-off points. They ensure you reach the right terminal on time, stress-free.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mrs. Shalini Jagtap",
            position: "Working Professional",
            text: "Mauli Cabs made my airport drop absolutely seamless. The driver arrived on time, the car was clean, and I reached Pune Airport well before my flight. Great service!",
            image: "/img/testimonial/testimonial-thumb-1-7.png",
        },
        {
            name: "Mr. Sagar More",
            position: "IT Consultant",
            text: "I've used Mauli Cabs multiple times for Pune Airport transfers. They’re always reliable, especially for my early morning flights. Highly recommended for business travelers.",
            image: "/img/testimonial/testimonial-thumb-1-8.png",
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    









    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7972733209",
            "+91 9763272775",

        ],
        email: "booking@maulicabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Car Rental",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Shirdi Cab Booking",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mahabaleshwar Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala - Khandala Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mumbai Airport Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Pune to Adlabs Imagica Cab Booking ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Best Cab Service For Matheran",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Ganpatipule Cab Booking",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Pandharpur Cab Booking",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Jyotirlinga Tour Package",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Ashtavinayak Darshan Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Best Cab From Pune to Murud Janjira",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Alibaug Affordable Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Ajanta Ellora Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Aurangabad Cab Booking",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Pune to Sade Teen Shakti Peeth Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Bhimashankar Round Trip",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Trimbakeshwar Best Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Nashik and Igatpuri Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Kolhapur Cab Booking",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Satara Cab Booking",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Tarkarli - Malvan Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Outstation Cab",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Goa Cab Booking",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Tuljapur Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Alandi - Dehu Darshan Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    const jsonData = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Pune Airport Cabs by Mauli Cabs",
        "description": "Mauli Cabs provides reliable and affordable airport cab services from Pune. Book your cab online for Mumbai Airport drops, Shirdi trips, and local or outstation airport transfers. Choose from private, luxury, or group options with 24x7 support and fixed rates.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "7200"
        }
      };
     
      


    return (
        <div>
            <GTag/>

 
<Helmet>
        <title>Pune Airport Cabs | Mauli Cabs | Call +91 7972733209</title>
        <meta
          name="description"
          content="Book reliable Pune Airport Cabs with Mauli Cabs. Get affordable rates for airport pickups and drops to Mumbai, Shirdi, or outstation. Choose from private or group taxi options. 24x7 online booking and professional drivers."
        />
        <meta
          name="keywords"
          content="Pune airport cabs, Mumbai airport to Pune cab, Pune Airport Cab Services, Pune Airport Taxi Booking, Pune Airport Car Rental, Pune Airport Taxi Rate, Pune Airport Cab Charges, Pune Airport Taxi Booking Online, Pune Airport Cab Pricing, Pune Airport Car Hire with Driver, Pune to Shirdi cab one way, Pune to Mumbai airport cab fare, Pune to Mumbai Airport, Pune Mumbai airport drop, Pune airport to shirdi cab, One way cab Mumbai to Pune, Pune Mumbai cab service, Pune to Mumbai Taxi Service, Pune airport to Shirdi taxi, Airport taxi Pune, Pune Airport Taxi, Outstation Car rental Pune, Airport Drop Pune, Pune airport to Shirdi cab price, airport cab service Pune, Airport pickup and drop Pune, Airport taxi service in Pune, Book Airport Cab Pune"
        />
        <script type="application/ld+json">
          {JSON.stringify(jsonData)}
        </script>
      </Helmet>


            <section
                className="vs-breadcrumb"
                style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
            >
                <div className="container">
                    <div className="row text-center">
                        <div className="col-12">
                            <div className="breadcrumb-content">
                                <h1 className="breadcrumb-title">{cardData.keyword}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/58.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mauli Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #631D02',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#631D02' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917972733209" className="d-block  text-white">+91 7972733209</a>
                                                <a href="tel:+919763272775" className="d-block  text-white">+91 9763272775</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:booking@maulicabs.com" className=" text-white d-block">
                                                    booking@maulicabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Mauli Cabs <br />
                                                    Pune Alandi Road , Wadmukkhwadi Charholi Bk, Alandi Devachi , Khed , Pune 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Puneairportcabs;